'use client'

import { APOLLO_CLIENT_SIDE_OPTIONS } from '@/lib/apollo/clients/apolloClient.client'
import { useQuery } from '@apollo/client'
import { gql } from '@gql-generated/gql'
import { __Private__UseSiteConfig__Document, type SiteConfigFragment } from '@gql-generated/graphql'

gql(/* GraphQL */ `
  fragment SiteConfig on Config {
    catalog {
      isPublicPricesEnabled
      isPublicStockEnabled
      isConnectedLocalStockVisible
      lengthReference
      isProductLabelGenerationEnabled
      isStoreNameDisplayedOnProductLabel
      isActiveHideVatPrice
    }
    customer {
      isAccountCreationEnabled
      isAddressAutocompleteEnabled
      europeanCountries {
        iso
        name
      }
      isAddressCreationEnabled
      isAddressDeletionEnabled
      isAddressEditionEnabled
    }
    pointOfSale {
      storeLocatorUrl
      isLocalStockByStoreEnabled
      isSubsidiaryDisplayEnabled
    }
    sales {
      isChorusDisplayEnabled
      isClickAndCollectEnabled
      isPunchoutLightEnabled
      isQuickOrderEnabled
      orderReferenceRegex
      deliveryTime {
        nbDayMinimum
        nbDayMaximum
        isSaturdayAvailable
        isSundayAvailable
      }
    }
    quotation {
      isQuotationEnabled
    }
    site {
      defaultCountryIso2
    }
  }

  # Naming this query likes this to avoid calling directly
  # You must use the "useSiteConfig" hook instead
  query __PRIVATE__UseSiteConfig__ {
    config {
      ...SiteConfig
    }
  }
`)

/**
 * Uses apollo cache if available and de-dupe queries even if one is already in loading
 */
export function useSiteConfig(): {
  config?: SiteConfigFragment
  loading: boolean
  error?: Error
} {
  const { data, loading, error } = useQuery(__Private__UseSiteConfig__Document, {
    ...APOLLO_CLIENT_SIDE_OPTIONS,
    fetchPolicy: 'cache-first',
    nextFetchPolicy: 'cache-first',
  })

  return {
    config: data?.config,
    loading,
    error,
  }
}
